// Pembatasan lokasi di sisi UI (cermin backend/siteScope.js). Backend tetap penjaga utama.
export const LOC_PERMS = { site_medan: 'medan', site_dumai: 'dumai', site_kijing: 'kijing', site_jakarta: 'jakarta' };
export const locOf = (name) => { const l = String(name || '').toLowerCase().replace(/\s*\(.*\)$/, '').trim(); return l === 'mempawah' ? 'kijing' : l; };
// null = semua lokasi; array = lokasi yang boleh.
export function allowedLocs(user) {
  if (!user || user.role === 'admin') return null;
  const p = Array.isArray(user.permissions) ? user.permissions : [];
  const s = Object.keys(LOC_PERMS).filter((k) => p.includes(k)).map((k) => LOC_PERMS[k]);
  return s.length ? s : null;
}
export const locOk = (allowed, name) => !allowed || allowed.includes(locOf(name));
